import { Nullable } from '@types'

import { UsersConfigResponse } from '../types'
import { getApiClient } from './apiClient'

export const fetchUserConfig = async (): Promise<Nullable<UsersConfigResponse>> => {
  const response = await getApiClient().get('')

  return response.data
}
